var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.117188 8.35745C0.117188 3.75363 3.84932 0.0214844 8.45314 0.0214844H31.7433C36.3471 0.0214844 40.0793 3.75362 40.0793 8.35744V31.6476C40.0793 36.2514 36.3471 39.9836 31.7433 39.9836H8.45315C3.84933 39.9836 0.117188 36.2514 0.117188 31.6476V8.35745Z",
    fill: "#155DFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4141_6440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5995 11.6738H15.1033C14.6615 11.6738 14.2378 11.8493 13.9254 12.1617C13.613 12.4741 13.4375 12.8978 13.4375 13.3396V26.6662C13.4375 27.108 13.613 27.5317 13.9254 27.8441C14.2378 28.1565 14.6615 28.332 15.1033 28.332H25.0982C25.54 28.332 25.9638 28.1565 26.2762 27.8441C26.5886 27.5317 26.7641 27.108 26.7641 26.6662V15.8384L22.5995 11.6738Z",
    stroke: "white",
    strokeWidth: 1.66582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7656 11.6738V15.0055C21.7656 15.4473 21.9411 15.871 22.2535 16.1834C22.5659 16.4958 22.9896 16.6713 23.4314 16.6713H26.7631",
    stroke: "white",
    strokeWidth: 1.66582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6016 22.5018L19.2674 24.1676L22.599 20.8359",
    stroke: "white",
    strokeWidth: 1.66582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4141_6440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9898,
    height: 19.9898,
    fill: "white",
    transform: "translate(10.1016 10.0078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefine);
export default __webpack_public_path__ + "static/media/define.62289a6044c0f4d755bfcfa3dd7e32a9.svg";
export { ForwardRef as ReactComponent };